import {
  linkToProgramOverview,
  linkToProgramUnit,
} from './'
import { APP_MAPPING_BY_SLUG } from "../../../config";
import { sortBy } from 'lodash';

function getOverviewNavItem(program, appCopy, activeHubSlug) {
  return {
    name: appCopy("overview"),
    shortName: appCopy("overview"),
    id: program.slug + appCopy("overview"),
    path: linkToProgramOverview(program.slug, activeHubSlug),
  };
}

function getNavItemsForProgram(program, appCopy, activeHubSlug) {
  const childUnits = program.level1ProgramUnits || [];
  
  const navItems = childUnits.map((unit) => {
    const level2Units = unit.level2ProgramUnits || [];
    
    return {
      name: unit.navTitle,
      id: unit.id,
      shortName: unit.tabTitle,
      path: linkToProgramUnit(unit.slug, program.slug, activeHubSlug),
      children: level2Units.map((level2Unit) => {
        const level3Units = level2Unit.level3ProgramUnits || [];
        
        return {
          name: level2Unit.title,
          id: level2Unit.id,
          path: linkToProgramUnit(level2Unit.slug, program.slug, activeHubSlug),
          children: level3Units.map((level3Unit) => {
            return {
              name: level3Unit.title,
              id: level3Unit.id,
              path: linkToProgramUnit(level3Unit.slug, program.slug, activeHubSlug),
            };
          }),
        };
      }),
    };
  });
  if (!program.showOverview) return navItems;
  // Prepend custom Overview nav item to array
  return [getOverviewNavItem(program, appCopy, activeHubSlug), ...navItems];
}

function getProgramLink(program, activeHubSlug) {
  const appMapping = APP_MAPPING_BY_SLUG[activeHubSlug];
  return program.showOverview
    ? linkToProgramOverview(program.slug, activeHubSlug)
    : `/${activeHubSlug}/${appMapping.route}/${program.slug}`;
}

function allProgramsNavItem(hubAppCopy, activeHubSlug) {
  const appMapping = APP_MAPPING_BY_SLUG[activeHubSlug];
  return {
    topLevelNav: hubAppCopy(`all${appMapping.plural}`),
    topLevelNavPath: "/" + activeHubSlug,
    navItems: [],
  };
}

function getSideNavItemsGroups(programs, program, appCopy, hubAppCopy, activeHubSlug) {
  // Sort programs alphabetically by programName (case-insensitive)
  const sortedPrograms = sortBy(programs, (p) => p.programName?.toLowerCase());

  const sideNavItems = program
    ? [
        {
          topLevelNav: program.programName,
          topLevelNavPath: getProgramLink(program, activeHubSlug),
          navItems: getNavItemsForProgram(program, appCopy, activeHubSlug),
        },
      ]
    : sortedPrograms.map((program) => ({
        topLevelNav: program.programName,
        topLevelNavPath: getProgramLink(program, activeHubSlug),
        navItems: [],
      }));
  return [allProgramsNavItem(hubAppCopy, activeHubSlug), ...sideNavItems];
}

export default getSideNavItemsGroups
